import { FedSearchResult } from '@moovio/moov-js';
import { hasOnlyDigits } from 'shared/utils/StringUtils';
import { yupObject, yupString } from 'shared/utils/YupUtils';
import { mixed } from 'yup';

export const INSTANT_VERIFICATION_CODE_LENGTH = 4;
const INSTANT_VERIFICATION_CODE_LENGTH_ERROR = 'Enter the 4-digit code';

export const instantVerificationSchema = yupObject({
  code: yupString()
    .required(INSTANT_VERIFICATION_CODE_LENGTH_ERROR)
    .length(
      INSTANT_VERIFICATION_CODE_LENGTH,
      INSTANT_VERIFICATION_CODE_LENGTH_ERROR,
    )
    .test('only-digits', INSTANT_VERIFICATION_CODE_LENGTH_ERROR, hasOnlyDigits),
});

export const uploadScreenshotSchema = yupObject({
  file: mixed<File>().required('File is required'),
});

export type MoovScope = 'account' | 'bank_account' | 'micro_deposit' | 'file';
type MoovBusinessType =
  | 'llc'
  | 'privateCorporation'
  | 'soleProprietorship'
  | 'partnership'
  | 'publicCorporation';

export const MOOV_BUSINESS_TYPES: MoovBusinessType[] = [
  'llc',
  'privateCorporation',
  'soleProprietorship',
  'partnership',
  'publicCorporation',
];

export const MOOV_BUSINESS_TYPE_DISPAY_NAMES: Record<MoovBusinessType, string> =
  {
    llc: 'LLC',
    privateCorporation: 'Private Corporation',
    soleProprietorship: 'Sole Proprietorship',
    partnership: 'Partnership',
    publicCorporation: 'Public Corporation',
  };

export interface MoovTokenResponse {
  access_token: string;
  moov_account_id: string | null; // null for account scope
  moov_bank_account_id: string | null; // not null for micro_deposit scope
}

export interface MoovInformation {
  access_token: string;
  moov_account_id: string | null; // null for account scope
  moov_bank_account_id: string | null; // not null for micro_deposit scope
}

export interface NewCarrierMoovAccount {
  businessType: MoovBusinessType;
  legalBusinessName: string;
  description: string;
  carrier_guid: string;
  einNumber: string;
}

export interface NewCarrierBankAccount {
  holderName: string;
  accountNumber: string;
  routingNumber: string;
}

export interface SyncMoovStep {
  scope: MoovScope;
  moov_account_id?: string | null;
  moov_bank_account_id?: string | null;
}

export interface MoovRequestError {
  statusCode?: number;
  error?: unknown;
}

export interface SearchRoutingNumberResponse extends FedSearchResult {
  result?: Array<{
    routingNumber: string;
    newRoutingNumber: string;
    customerName: string;
    cleanName: string;
    logo: string | null;
    officeCode: string;
    phoneNumber: string;
    recordTypeCode: string;
    revised: string;
    servicingFRBNumber: string;
    statusCode: string;
    viewCode: string;
    achLocation: {
      address: string;
      city: string;
      postalCode: string;
      postalCodeExtension: string;
      state: string;
    };
  }>;
}
